import * as React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { RiskTemplate } from "types";
import { Options } from "./RowOptions";

interface CustomRiskProps extends RiskTemplate {}

export const RiskTemplateRow = (props: CustomRiskProps) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { crn, payload } = props;

  const [showOptions, setShowOptions] = React.useState(false);

  const navigateToEdit = () => {
    history.push(`/risk-templates/${crn}`);
  };

  return (
    <tr className="hover:bg-gray-50 cursor-pointer">
      <td
        onClick={navigateToEdit}
        className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
      >
        {payload.blueprint_name || payload.id}
      </td>
      <td
        onClick={navigateToEdit}
        className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
      >
        {t(
          "form.risk.options.group." + payload.group_id,
          t("riskTemplate.selection.noGroup")
        )}
      </td>
      <td
        onClick={navigateToEdit}
        className="px-6 py-4 whitespace-normal text-sm text-gray-500 max-w-xs"
      >
        {payload.blueprint_description || "-"}
      </td>
      <td className="pr-6">
        <div className="relative flex justify-end items-center">
          <button
            type="button"
            className="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
            id="standard-options-menu-0"
            aria-expanded="false"
            aria-haspopup="true"
            onClick={() => {
              setShowOptions(true);
            }}
          >
            <span className="sr-only">Open options</span>
            <svg
              className="w-5 h-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
            </svg>
          </button>
          {showOptions && (
            <Options
              onClose={() => setShowOptions(false)}
              riskTemplate={props}
            />
          )}
        </div>
      </td>
    </tr>
  );
};
